import {Component, OnInit} from '@angular/core';
import {AppConstants} from '../utils/constants';
import {Router} from "@angular/router";
import {AuthDetailsService} from "../auth/auth-details.service";

@Component({
    selector: 'app-home-page',
    templateUrl: './home-page.component.html',
    styleUrls: ['./home-page.component.scss'],
    standalone: false
})
export class EntryPageComponent implements OnInit {

  manageCustomersPath = AppConstants.slxAdminManageCustomers;
  manageUsersPath = AppConstants.slxAdminManageUsers;
  manageCompanyDataPath = AppConstants.changeCompanyData;
  manageCompanyUsersPath = AppConstants.adminUsersOverviewPath;

  isUserAllowedToManageCustomers: boolean = false;
  isUserAllowedToManageUsers: boolean = false;
  isUserAllowedToManageCompanyData: boolean = false;
  isUserAllowedToManageCompanyUsers: boolean = false;


  private loading = false;

  constructor(
    private _authService: AuthDetailsService,
    private _router: Router
  ) {
  }

  ngOnInit() {
    this.loading = true;

    this._authService.getAccessControlData(
      this.manageCustomersPath,
      this.manageUsersPath,
      this.manageCompanyDataPath,
      this.manageCompanyUsersPath
    ).subscribe(
     response => {
       if(response) {
         this.isUserAllowedToManageCustomers = response.get(this.manageCustomersPath);
         this.isUserAllowedToManageUsers = response.get(this.manageUsersPath);
         this.isUserAllowedToManageCompanyData = response.get(this.manageCompanyDataPath);
         this.isUserAllowedToManageCompanyUsers = response.get(this.manageCompanyUsersPath);
       }
       this.loading = false;
    });

  }

  public getLoading() {
    return this.loading;
  }


}
